import React from "react";
import screenshot1 from "./screenshot1.png";
import screenshot6 from "./6.png";
import screenshot8 from "./8.png";
import screenshot7 from "./7.png";
import logo from "./logo.svg";
import appstoreicon from "./appstore.svg";
import playstoreicon from "./play.png";
import { IoMdHeartDislike } from "react-icons/io";
import { GiGooeyImpact } from "react-icons/gi";

export default function Home() {
  return (
    <div>
      <div className="top-container">
        <img className="logo" src={logo} alt={"logo"}></img>

        <img className="screenshots" src={screenshot1} alt={"screenshot"}></img>
      </div>

      <div className="section--brand-info">
        <h1 className="title">
          Getting better <span className="focus-text">together</span>, one day at a time.
        </h1>
        <p className="text">
          Cultivating a community dedicated to inspiration and motivation by getting a little better each and every day.
        </p>
      </div>
      <div className="section app-store-icons">
        <img className="store-logo" src={appstoreicon} alt={"app-store"}></img>
        <img className="store-logo" src={playstoreicon} alt={"play-store"}></img>
      </div>
      <div className="section-container">
        <div className="section--themed">
          <h1 className=" title title--alternate">Share Your Progress</h1>
          <p className="text text--subtitle">
            Ditching likes <IoMdHeartDislike /> for impact <GiGooeyImpact />
          </p>
          <img className="screenshots" src={screenshot6} alt={"screenshot"}></img>
        </div>
        <div className="section--themed">
          <h1 className="title title--alternate">Build a Community</h1>
          <p className="text text--subtitle"></p>
          <img className="screenshots" src={screenshot8} alt={"screenshot"}></img>
        </div>
        <div className="section--themed">
          <h1 className="title title--alternate">Make it Your Journey</h1>
          <p className="text text--subtitle"></p>
          <img className="screenshots" src={screenshot7} alt={"screenshot"}></img>
        </div>
      </div>

      <div className="section--brand-info">
        <h1 className="title title--alternate">Purpose Over Profit</h1>
        <p className="text">
          compoundit is 100% free but if you'd like to show your support and fund future development, for cool, new
          features, you can subscribe to our{" "}
          <a className="patreon-link" href="https://www.patreon.com/compoundit">
            Patreon
          </a>
          . Thank you for your support!
        </p>
      </div>
      <div className="footer-section">
        <a href="privacy">Privacy Policy</a>
        <a href="terms">Terms of Use</a>
      </div>
    </div>
  );
}
